module.exports = __webpack_public_path__ + "d0b42dd7a94a4399d03606cecc36e324.png";